import { SVGProps } from "react";

export const Divider = ({
    width = "100%"
}: Pick<SVGProps<SVGSVGElement>, "width">) => (
    <svg
        style={{ display: "block" }}
        width={width}
        height="2"
        viewBox={`0 0 ${width} 0`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <line
            x1="0.5"
            y1="1.19824"
            x2={width}
            y2="1.19824"
            stroke="#DDDEE1"
            strokeLinecap="round"
            strokeDasharray="0.5 4"
        />
    </svg>
);
